export const getState = () => {
  const store = window.store || window.booqableStore

  return store && store.getState()
}

export default getState
